import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, resolveDynamicComponent as _resolveDynamicComponent, toHandlers as _toHandlers, mergeProps as _mergeProps, createBlock as _createBlock, KeepAlive as _KeepAlive, resolveComponent as _resolveComponent, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "container pt-3" }
const _hoisted_2 = { class: "row" }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("hr", null, null, -1)

import {IBottomSheet} from "@/interfaces/components/general/IBottomSheet";
import {computed, ref, watch} from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'BottomSheet',
  props: {
    bottomSheet: null
  },
  setup(__props: any) {

const props = __props as {
  bottomSheet: IBottomSheet,
}

const isModal = ref(false)


const computedBottomSheet = computed(() => props.bottomSheet);

watch(computedBottomSheet, (value) => {
  isModal.value = value.show
}, {deep: true})


return (_ctx: any,_cache: any) => {
  const _component_swipe_modal = _resolveComponent("swipe-modal")!

  return (_unref(computedBottomSheet))
    ? (_openBlock(), _createBlock(_component_swipe_modal, {
        key: 0,
        modelValue: isModal.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((isModal).value = $event)),
        "contents-height": "70vh",
        "border-top-radius": "16px"
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              (_unref(computedBottomSheet).title)
                ? (_openBlock(), _createElementBlock("h4", _hoisted_3, _toDisplayString(_unref(computedBottomSheet).title), 1))
                : _createCommentVNode("", true),
              _hoisted_4
            ]),
            (_unref(computedBottomSheet).content)
              ? (_openBlock(), _createBlock(_KeepAlive, { key: 0 }, [
                  (_openBlock(), _createBlock(_resolveDynamicComponent(_unref(computedBottomSheet).content.render), _mergeProps({
                    class: _unref(computedBottomSheet).content.customClass ?? ''
                  }, _toHandlers(_unref(computedBottomSheet).content.events ?? []), _unref(computedBottomSheet).content.content ?? {}), null, 16, ["class"]))
                ], 1024))
              : _createCommentVNode("", true)
          ])
        ]),
        _: 1
      }, 8, ["modelValue"]))
    : _createCommentVNode("", true)
}
}

})